import { CrudDataSetListComponent } from './crud-data-set-list';
import { CrudDataSetFormComponent } from './crud-data-set-form';
import { CurdDataSetConfig } from '@mri/types';
import { Routes } from '@angular/router';

export class CrudDataSetModule {
   static register(config: CurdDataSetConfig): Routes {
     const routes: Routes = [];

     const { form, list, pages } = config;

     if (pages.includes('list') && list) {
       routes.push({
         path: 'list',
         component: CrudDataSetListComponent,
         providers: [
           {
             provide: 'CRUD_DATA_FORM_CONFIG',
             useValue: config
           }
         ]
       });
     }

     if (pages.includes('create') && form) {
       routes.push({
         path: 'create',
         component: CrudDataSetFormComponent,
         providers: [
           {
             provide: 'CRUD_DATA_FORM_ACTION',
             useValue: 'create'
           },
           {
             provide: 'CRUD_DATA_FORM_CONFIG',
             useValue: config
           }
         ]
       });
     }

     if (pages.includes('edit') && form) {
       routes.push({
         path: ':id/edit',
         component: CrudDataSetFormComponent,
         providers: [
           {
             provide: 'CRUD_DATA_FORM_ACTION',
             useValue: 'edit'
           },
           {
             provide: 'CRUD_DATA_FORM_CONFIG',
             useValue: config
           }
         ]
       });
     }

     return routes;
   }
}
